<div class="container-fluid code-container">
  <div class="row justify-content-center align-items-center text-center">
    
    <div class="col-12 col-md-8 col-lg-6">
      
      <!-- Title -->
      <h4 class="appointment-form-title" [ngClass]="{'rtl': dir==='ar'}">
        {{ dir === 'fr' 
          ? 'Merci de saisir le code envoyé par SMS' 
          : 'الرجاء إدخال الرمز المرسل عبر الرسائل القصيرة' }}
      </h4>

      <!-- Code input -->
      <div class="form-group code-input-wrapper">
        <app-code-input 
          [length]="5" 
          [(value)]="code" 
          [dir]="dir === 'ar' ? 'ltr' : 'ltr'">
        </app-code-input>
      </div>

      <!-- Error -->
      <div *ngIf="validating && !valid" class="error-text">
        {{ dir === 'fr' ? 'Code invalide' : 'رمز غير صحيح' }}
      </div>

    </div>

  </div>
</div>